import React, { useState } from "react";
import { Eye, EyeOff, Lock } from "lucide-react";

export default function PasswordInput({ value, onChange, placeholder, testid, minLength = 6, autoComplete = "current-password" }) {
  const [show, setShow] = useState(false);
  return (
    <div className="mt-1 flex items-center border border-slate-200 rounded-xl px-3 focus-within:border-emerald-500">
      <Lock className="w-4 h-4 text-slate-400 flex-shrink-0" />
      <input
        type={show ? "text" : "password"} value={value} onChange={(e) => onChange(e.target.value)} required minLength={minLength}
        placeholder={placeholder} autoComplete={autoComplete} className="w-full min-w-0 px-3 py-3 text-sm outline-none" data-testid={testid}
      />
      <button type="button" onClick={() => setShow((s) => !s)} className="p-1.5 -mr-1 text-slate-400 hover:text-slate-700 flex-shrink-0" aria-label={show ? "Hide password" : "Show password"} data-testid={`${testid}-toggle`}>
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
